import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const CentralOpenRequest = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const request = location.state?.openRequest;

  if (!request) {
    return (
      <div className="p-6">
        <h2 className="text-xl font-bold text-red-600">No Request Data Found</h2>
        <button
          onClick={() => navigate(-1)}
          className="mt-4 bg-yellow-600 text-white px-4 py-2 rounded-lg"
        >
          Go Back
        </button>
      </div>
    );
  }

  return (
    <div className="p-6">
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold text-yellow-600">
          Request #{`${request._id}`.slice(-5)}
        </h2>
        <span
          className={`text-sm font-semibold px-3 py-1 rounded-full ${
            request.status === 'PENDING'
              ? 'bg-pink-100 text-pink-800'
              : 'bg-green-100 text-green-800'
          }`}
        >
          {request.status}
        </span>
      </div>

      {/* Menu info */}
      <div className="bg-white rounded-lg shadow-md p-4 mb-6 border border-gray-200">
        <h3 className="text-lg font-semibold mb-2">Menu</h3>
        <p className="text-gray-500 text-sm">
  {Array.isArray(request.menu) && request.menu.length > 0
    ? request.menu.map((m) => m.name).join(', ')
    : 'No Menu'}
</p>
      </div>

      {/* Items */}
      <div className="bg-white rounded-lg shadow-md p-4 border border-gray-200">
        <h3 className="text-lg font-semibold mb-4">Requested Items</h3>
        {request.items && request.items.length > 0 ? (
          <ul className="space-y-3">
            {request.items.map((item, idx) => (
              <li
                key={idx}
                className="flex justify-between items-center border-b pb-2"
              >
                <div>
                  <p className="font-medium text-gray-800">
                    {item?.item?.name || 'Unknown Item'}
                  </p>
                  <p className="text-sm text-gray-500">
                    Qty: {item?.quantity} {item?.unit}
                  </p>
                </div>
                <div className="text-sm text-gray-500">
                  {item?.supplier?.id?.name && (
                    <p>Supplier: {item.supplier.id.name}</p>
                  )}
                  {item?.zoneSupplier?.id?.name && (
                    <p>Zone Supplier: {item.zoneSupplier.id.name}</p>
                  )}
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-gray-500">No items found for this request.</p>
        )}
      </div>

      {/* Back button */}
      <div className="mt-6">
        <button
          onClick={() => navigate(-1)}
          className="bg-yellow-600 text-white px-4 py-2 rounded-lg"
        >
          Back to Requests
        </button>
      </div>
    </div>
  );
};

export default CentralOpenRequest;
